import { Route, Routes } from "react-router-dom";
import { split } from "lodash";
import { useLocation } from "react-router-dom";

import { AuthGuard, GuestGuard } from "./guards";
import {
  ErrorPage,
  NotFoundPage,
  RequestCodePageResolver,
  SchedulerSummaryPageResolver,
  SchedulerWizardPageResolver,
  UnderConstructionPage,
  ValidateCodePage,
} from "./pages";
import { useAppSelector } from "./redux/store";

const Root = () => {
  const isInMaintenance = !!process.env.REACT_APP_MAINTENANCE_MODE;

  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const vendorUrl = useAppSelector((state) => state.auth.vendorURL);

  const { pathname } = useLocation();
  const vendorFromUrl = split(pathname, "/")[1];
  const isSameVendor = vendorUrl === vendorFromUrl && isAuthenticated;

  return isInMaintenance ? (
    <UnderConstructionPage />
  ) : (
    <Routes>
      <Route
        path="/:vendorUrl"
        errorElement={<ErrorPage />}
        element={
          <GuestGuard
            isAuthenticated={isSameVendor}
            redirectPath={isSameVendor ? `/${vendorUrl}/request` : `/${vendorFromUrl}`}
            component={RequestCodePageResolver}
          />
        }
      />

      <Route
        path="/:vendorUrl/validate"
        errorElement={<ErrorPage />}
        element={
          <GuestGuard
            isAuthenticated={isAuthenticated}
            redirectPath={vendorUrl ? `/${vendorUrl}/request` : `/`}
            component={ValidateCodePage}
          />
        }
      />

      <Route
        path="/:vendorUrl/request"
        errorElement={<ErrorPage />}
        element={
          <AuthGuard
            isAuthenticated={isAuthenticated}
            redirectPath={`/${vendorUrl || ""}`}
            component={SchedulerWizardPageResolver}
          />
        }
      />
      <Route
        path="/:vendorUrl/summary/:requestId"
        errorElement={<ErrorPage />}
        element={<SchedulerSummaryPageResolver />}
      />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default Root;
